module.exports = __webpack_public_path__ + "b3d3d9582d39947f6e040e8cfeccbc3e.ttf";